import { useCallback } from 'react';
import { creatorbase } from '@round/api';
import { useInvalidateAggregatedPostStats } from '@round/creatorbase-helpers/api-hooks';
import { useInvalidateProjectData } from '../useProjectDetails';
import useInvalidateProjectCampaigns from './useInvalidateProjectCampaigns';

type Args = {
    project_id: number;
    platform: creatorbase.Platform;
};

export default function useInvalidateProjectCampaignContext() {
    const invalidateAggregatedPostStats = useInvalidateAggregatedPostStats();
    const invalidateProjectData = useInvalidateProjectData();
    const invalidateProjectCampaigns = useInvalidateProjectCampaigns();

    return useCallback(
        ({ project_id, platform }: Args) =>
            Promise.all([
                invalidateAggregatedPostStats({ project_id, platform }).catch(() => {}),
                invalidateProjectData().catch(() => {}),
                invalidateProjectCampaigns(platform).catch(() => {}),
            ]),
        [invalidateAggregatedPostStats, invalidateProjectData, invalidateProjectCampaigns]
    );
}
